import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListServerPaginationStateModel } from '../../../../../../../common/models';
import { getQueryStringFromObject } from '../../../../../../../common/utils';
import { API_URL } from '../../../../../../../services/config';
import { WrapperHttpService } from '../../../../../../services/wrapper-http-service';
import { HubEndpoint } from '../../../../hub/constants/hub-endpoint';
import { CompartmentEndpoint } from '../../../constants/compartment-endpoint';
import {
  CompartmentRuleListItem,
  CompartmentRuleListSearchCriteria,
  CompartmentRuleListURIParams,
} from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class CompartmentRuleListService {
  constructor(private http: WrapperHttpService) {}

  getCompartmentRuleList({
    hubId,
    compartmentId,
    searchCriteria,
  }: CompartmentRuleListURIParams): Observable<ListServerPaginationStateModel<CompartmentRuleListItem>> {
    const { size, page, ...filterView } = searchCriteria;
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${
      CompartmentEndpoint.Rules
    }${CompartmentEndpoint.Search}?${getQueryStringFromObject({
      page,
      size,
    })}`;
    return this.http.withLoading().post<ListServerPaginationStateModel<CompartmentRuleListItem>>(url, filterView);
  }

  downloadCompartmentRulesList(body: {
    name: string;
    filterView: Partial<CompartmentRuleListSearchCriteria>;
    hubId: number;
    compartmentId: number;
  }): Observable<void> {
    const url =
      `${API_URL}${HubEndpoint.Exports}${HubEndpoint.Base}/${body.hubId}${CompartmentEndpoint.Base}/${body.compartmentId}${CompartmentEndpoint.Rules}` +
      '?name=' +
      body.name;
    return this.http.withLoading().post<void>(url, body.filterView);
  }
}
